import EmailIcon from '@mui/icons-material/Email';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';

const tone: keyof typeof Palette = 'default';

/** "New Message" title bar for StatementEmailComposePanel. */
const StatementEmailComposeHeader: React.FC = () => (
  <Box
    sx={{
      p: 2,
      borderBottom: `1px solid ${Palette[tone].border}`,
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <EmailIcon sx={{ color: Palette[tone].text }} />
      <Typography variant="h6" sx={{ fontWeight: 500 }}>
        New Message
      </Typography>
    </Box>
  </Box>
);

export default StatementEmailComposeHeader;
